import { attachmentsApi } from './queries/attachments'
import { authApi } from './queries/auth'
import { cartApi } from './queries/cart'
import { claimRecordsApi } from './queries/claimRecords'
import { configApi } from './queries/config'
import { guestCustomerApi } from './queries/guestCustomer'
import { insurersApi } from './queries/insurers'

export const middleware = [
  authApi.middleware,
  insurersApi.middleware,
  claimRecordsApi.middleware,
  configApi.middleware,
  attachmentsApi.middleware,
  cartApi.middleware,
  guestCustomerApi.middleware,
]
